/* app/js/src/components/common/tabs/tabs.component.scss */
.container .tabs-wrapper .license-wrapper ul,
.container .tabs-wrapper li > section:last-child > ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.cursor-pointer {
  cursor: pointer;
}
.container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.container::-webkit-scrollbar-corner {
  background: transparent;
}
.container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.container::-webkit-scrollbar-thumb {
  border-width: 0;
}
:host {
  overflow: hidden;
  position: absolute;
  display: block;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.label-generic,
.container .tabs-wrapper .license-wrapper > section > div > label,
.frame-format-label,
.start-timestamp-ms-field {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
}
nav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: transparent;
  padding: 0 25px;
  -ms-transform: translate(0px, 0px);
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
}
nav a {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  min-width: 100px;
  max-width: fit-content;
  display: block;
  text-decoration: none;
  text-transform: uppercase;
  color: #6d7780;
  text-align: center;
  font-size: 0.9em;
  font-stretch: normal;
  font-weight: 600;
  background-color: #e3e7eb;
  border-radius: 3px 3px 0 0;
  margin-right: 2px;
  cursor: pointer;
  height: 31px;
  line-height: 31px;
  padding: 2px 10px 0 10px;
}
nav a.active {
  background-color: #ffffff;
  color: #232f3a;
  font-weight: 800;
  text-decoration: underline;
  text-decoration-thickness: 1.5px;
  text-underline-offset: 1px;
}
.container {
  height: 85%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-left: 33px;
}
.container h4 {
  margin: 20px 0 20px 14px;
  font-weight: 400;
  font-size: 0.95em;
}
.container .tabs-wrapper {
  list-style-type: none;
  width: 100%;
  padding: 0;
  overflow-x: visible;
  overflow-y: visible;
  margin-bottom: 0;
  margin-top: 5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.container .tabs-wrapper li {
  min-width: 90%;
  padding: 0 14px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.container .tabs-wrapper li > section {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  position: relative;
}
.container .tabs-wrapper li > section:last-child {
  padding-right: 2.5vw;
}
.container .tabs-wrapper li > section:last-child > ul {
  display: block;
  position: absolute;
  bottom: 25px;
  margin: 0;
  width: 85%;
  display: none;
}
.container .tabs-wrapper li > section:last-child > ul li {
  padding: 0;
  margin-top: 5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
.container .tabs-wrapper li > section:last-child > ul li button {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: none;
  border: none;
  color: #40c4ff;
  margin: 5px 0;
  padding-left: 0;
}
.container .tabs-wrapper li > section:last-child > ul li button svg {
  fill: #40c4ff;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .tabs-wrapper li > section:last-child > ul li button span {
  font-size: 0.9em;
  font-weight: 100;
  display: block;
  margin-left: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .tabs-wrapper li > section:last-child > ul li button:focus {
  outline: none;
}
.container .tabs-wrapper li > section:last-child > ul li button:hover {
  color: #232f3a;
}
.container .tabs-wrapper li > section:last-child > ul li button:hover svg {
  fill: #232f3a;
}
.container .tabs-wrapper li > section:last-child > ul li .thumbnail {
  width: 20%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center right;
  cursor: pointer;
}
.container .tabs-wrapper li .divider {
  border: none;
  max-width: 1px;
  margin: 0px 2.5vw 25px;
  background-color: #e1e6eb;
}
.container .tabs-wrapper .license-wrapper {
  margin-bottom: 4vh;
}
.container .tabs-wrapper .license-wrapper > section > div:first-child {
  margin-bottom: 1.5em;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.container .tabs-wrapper .license-wrapper > section > div:first-child label {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.container .tabs-wrapper .license-wrapper > section > div:first-child icn-dropdown {
  width: auto !important;
}
.container .tabs-wrapper .license-wrapper > section > div > label {
  line-height: 3em;
}
.container .tabs-wrapper .license-wrapper ichannel-dropdown label {
  border: 3px solid black;
  white-space: nowrap;
}
.container .tabs-wrapper .license-wrapper ul {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.container .tabs-wrapper .license-wrapper ul li {
  margin: 0 10px 20px 0;
  padding: 0;
  width: 48%;
  min-width: 48%;
  max-width: 48%;
  -webkit-flex: 1 0 auto;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.container .tabs-wrapper .license-wrapper ul li label {
  font-weight: 600;
  display: block;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 0em;
  -webkit-flex: 2 0 auto;
  -ms-flex: 2 0 auto;
  flex: 2 0 auto;
}
.container .tabs-wrapper .license-wrapper ul li dateinput {
  -webkit-flex: 1 0 auto;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  display: block;
  position: relative;
}
.container .tabs-wrapper .license-wrapper ul li dateinput::after {
  content: "Start Date";
  position: absolute;
  bottom: -1.3em;
  font-size: 0.6em;
  left: 0.1em;
  text-transform: uppercase;
  color: #879baf;
  opacity: 0;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
}
.container .tabs-wrapper .license-wrapper ul li dateinput:last-child {
  margin-left: 5px;
}
.container .tabs-wrapper .license-wrapper ul li dateinput:last-child::after {
  content: "Date";
}
.container .tabs-wrapper .license-wrapper ul li dateinput:hover::after {
  opacity: 1;
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
}
footer {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  margin: 0 14px 14px;
}
footer > div {
  display: inline-block;
  text-align: right;
  padding-top: 1.5vh;
}
footer > div ichannel-button:first-child {
  margin-right: 10px;
}
.tenant-media-id-container {
  position: relative;
  text-align: right;
}
.tenant-media-id-container .tenantMediaIdInput {
  text-align: left;
}
.tenant-media-id-container .tenant-media-id-status {
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translate(0, -50%);
}
.tenant-media-id-container .tenant-media-id-status.fa-exclamation {
  color: #ef5350;
}
.tenant-media-id-container .tenant-media-id-status.fa-check {
  color: #1de9b6;
}
.tenant-media-id-container circle-indicator {
  position: absolute;
  right: -25px;
  top: 50%;
  -ms-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}
.meta-data-tab {
  display: flex;
  flex-direction: column;
}
.meta-data-header {
  margin-bottom: 30px;
  margin-top: -7px;
}
.meta-data-header h4 {
  display: inline;
  margin-left: 1px;
}
.meta-data-header icn-dropdown {
  float: right;
  display: inline-block;
}
.meta-data-body {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 25vh;
  margin-right: 150px;
}
.meta-data-body .left-meta-data-body {
  padding-right: 25px;
}
.meta-data-body .left-meta-data-body,
.meta-data-body .right-meta-data-body {
  height: 100%;
  width: 50%;
}
.meta-data-body .left-meta-data-body ichannel-input,
.meta-data-body .right-meta-data-body ichannel-input {
  padding-bottom: 3px;
}
.change-meta-data-language-label {
  font-family: Open Sans;
  font-size: 12px;
  color: #7d8fa1;
  display: inline;
  float: right;
  padding-top: 8px;
  margin-right: 15px;
}
.frame-format-label {
  line-height: 3em;
}
.start-timestamp-ms {
  height: 40px;
  margin-top: 20px;
}
.start-timestamp-ms evrideo-time-editor {
  display: inline-block;
}
.frame-format-container {
  display: flex;
}
.frame-format-dropdown {
  flex-grow: 1;
}
.copy-button {
  float: right;
}
.copy-button:hover svg {
  fill: #444;
}
.copy-button.hidden {
  visibility: hidden;
}
.video-id-icons {
  position: absolute;
  display: inline-block;
  padding-top: 5px;
  margin-left: -23px;
}
.floating-media-depth {
  margin-top: 13px;
}
.media-should-squeeze-container {
  display: flex;
  justify-content: start;
  gap: 15px;
  margin-top: 15px;
}
.qc-status-table {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
  table-layout: fixed;
}
.qc-status-table th,
.qc-status-table td {
  padding: 12px 16px;
  border: 1px solid transparent;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.qc-status-table th:nth-child(1),
.qc-status-table td:nth-child(1) {
  width: auto;
  max-width: 1px;
  white-space: normal;
}
.qc-status-table th:nth-child(2),
.qc-status-table td:nth-child(2) {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}
.qc-status-table th:nth-child(2) select,
.qc-status-table td:nth-child(2) select {
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 16px;
  color: #212529;
  font-weight: 400;
  line-height: 1.5;
}
.qc-status-table th:nth-child(3),
.qc-status-table td:nth-child(3) {
  width: 25vw;
}
.tab-dot {
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
  margin-right: 0.2em;
  vertical-align: middle;
  background-color: transparent;
}
/*# sourceMappingURL=tabs.component.css.map */
